module.exports = {
  CHRONIC_PAIN_WORKSPACE_ID: 'o_chronic_pain_0'
};
